export default __webpack_public_path__ + "static/article-how-to-maximise-savings-v1-9d165ca096be7b465c290dc7000ba290.jpg";